import { Language, ReduxState, TextDirection } from 'interface';
import React, { useEffect, useRef, useState } from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { __PhoneRef, __PhoneProps } from './mobile.interface';
import './mobile.style.scss';
import HintText from '../hintText/hintText.index';
import QuestionImage from '../questionImage/questionImage.index';
import { prsNum2Eng } from 'scripts/string';
import { extractTitle } from 'scripts/string';
export interface SLPMobileRef extends __PhoneRef {}

const SLPMobileInput: React.ForwardRefRenderFunction<__PhoneRef, ConnectedProps<typeof connector> & __PhoneProps> = (
    props: ConnectedProps<typeof connector> & __PhoneProps,
    ref,
) => {
    const lang = props.lang.utilities;
    const inputRef = useRef<HTMLInputElement>(null);
    const [error, setError] = useState<string>();
    const labelRef = useRef<HTMLLabelElement>(null);
    const [active, setActive] = useState<boolean>(false);
    /* const [selected, setSelected] = useState<__PhoneCode>({
        name: 'Iran, Islamic Republic of Persian Gulf',
        flag: '🇮🇷',
        code: 'IR',
        dial_code: '+98',
    }); */
    const immediateValue = useRef(props.defaultValue ? props.defaultValue : '');
    const [value, setValue] = useState<string>(immediateValue.current);
    React.useImperativeHandle(ref, () => ({
        getValue: () => (inputRef.current ? inputRef.current.value : ''),
        setError: (text) => {
            setError(text);
        },
        getPureValue: () => (inputRef.current ? inputRef.current.value : ''),
    }));

    useEffect(() => {
        if (labelRef.current && props.label) labelRef.current.innerHTML = extractTitle(props.label, false);
    }, [props.label]);

    function onFocusHandler() {
        setActive(true);
    }
    function onblurHandler() {
        setActive(false);
    }
    function onChangeHandler(e: React.FocusEvent<HTMLInputElement>) {
        setError(undefined);
        const newValue: string = prsNum2Eng(e.target.value);
        if (newValue.length === 0 || newValue === '0' || (newValue.match(/^(09)\d*$/) && newValue.length <= 11)) {
            immediateValue.current = newValue;
            setValue(immediateValue.current);
            if (props.onChange) props.onChange(immediateValue.current);
        }
    }
    function onKeyPress(e: React.KeyboardEvent<HTMLInputElement>) {
        if (e.charCode === 13 && props.onEnter) {
            e.preventDefault();
            e.currentTarget.blur();
            props.onEnter(immediateValue.current);
        }
    }
    return (
        <div
            onClick={() => inputRef.current?.focus()}
            className={`ucheck-SLP-international-phone ${value.length ? 'filled' : ''} ${active ? 'active' : ''} ${
                error ? 'error' : ''
            }  ${props.dir === TextDirection.rtl ? 'rtl-text' : ''}`}
        >
            <span className="d-flex">
                {props.required && <span className="required-star">*</span>}
                <span className="counter-span">{props.counter ? props.counter + '- ' : ''}</span>
                <label ref={labelRef} style={{ color: props.labelColor }} />
            </span>
            <QuestionImage src={props.image?.file} />
            <HintText value={props.hint} />
            <div className={`input-box  ${props.endIcon ? 'has-end-icon' : ''} `}>
                <input
                    ref={inputRef}
                    value={value}
                    type="tel"
                    onFocus={onFocusHandler}
                    onBlur={onblurHandler}
                    onChange={onChangeHandler}
                    onKeyPress={onKeyPress}
                    style={{ color: props.color }}
                    required={props.required}
                    placeholder={props.formLang === Language.en ? lang.SLPMobilePHEn : lang.SLPMobilePH}
                    enterKeyHint="next"
                />
                {props.endIcon && (
                    <i className="material-icons" style={{ color: props.endIcon.color }}>
                        {props.endIcon.icon}
                    </i>
                )}
                {/* <DropdownButton title={selected.flag}>
                    {__phoneData.map((item, index) => (
                        <Dropdown.Item
                            onSelect={() => {
                                setSelected(item);
                            }}
                            key={index}
                        >
                            {item.flag + ' ' + item.dial_code}
                        </Dropdown.Item>
                    ))}
                </DropdownButton> */}
            </div>
            {error && <p className="input-error">{error}</p>}
        </div>
    );
};

const mapStateToProps = (state: ReduxState) => ({
    lang: state.lang,
});

const connector = connect(mapStateToProps, null, null, { forwardRef: true });
export default connector(React.forwardRef(SLPMobileInput));
